module.exports = __webpack_public_path__ + "static/media/eye.5fc83686.svg";